// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__2u9pD","activePage":"Pagination_activePage__wpkUX","ellipsis":"Pagination_ellipsis__3dXrJ"};